import { Component } from '@angular/core';
import { ChatService } from '../../chat.service';
import { ChatUiService } from '../../chat-ui.service';
import { unreadBadge } from '../../ui/unread-badge';

/** The header's chat icon: toggles the same floating window as the sidebar item, with the unread count as a badge. */
@Component({
  selector: 'app-chat-launcher',
  template: `
    <button mat-icon-button *ngIf="(chat.enabled$ | async) !== false" (click)="ui.toggle()"
      matTooltip="Chat" aria-label="Chat">
      <mat-icon color="primary" [matBadge]="badge(chat.unread$ | async)" [matBadgeHidden]="!(chat.unread$ | async)"
        matBadgeColor="warn">forum</mat-icon>
    </button>
  `,
})
export class ChatLauncherComponent {
  constructor(readonly chat: ChatService, readonly ui: ChatUiService) {}

  readonly badge = unreadBadge;
}
